import React from 'react';

// Pagina nascosta /legis-terms: non linkata da nessun pulsante/menu.
// Contenuto statico (IT) fornito per l'app Legis.
const LegisTerms: React.FC = () => {
  return (
    <div className="min-h-screen bg-void-blue text-white">
      <main className="container mx-auto px-4 py-12 mt-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="font-display text-4xl font-bold text-white mb-4">
              Termini e Condizioni di Servizio dell’App &ldquo;Legis&rdquo;
            </h1>
            <p className="text-sm text-gray-400 mb-6">Ultimo aggiornamento: 16 settembre 2026</p>
            <p className="mb-4 text-gray-300">
              Benvenuta/o su Legis (“l’Applicazione”). L’Applicazione è gestita e fornita da LegisRatio S.r.l., con sede
              in piazzale Lavater, 3 – 20133 Milano (MI), Italia (“Titolare”, “noi”). Contatto:{' '}
              <a href="mailto:privacy@legisratio.it" className="text-mystic-violet hover:text-cosmic-teal underline">
                privacy@legisratio.it
              </a>
              .
            </p>
            <p className="text-gray-300">
              Registrandoti, accedendo o utilizzando Legis, l&apos;utente (&ldquo;Utente&rdquo;, &ldquo;tu&rdquo;) accetta
              integralmente e senza riserve i presenti Termini e Condizioni di Servizio (&ldquo;Termini&rdquo;). Se non
              accetti i presenti Termini, ti invitiamo a non utilizzare l&apos;Applicazione.
            </p>
          </div>

          <div className="space-y-6 text-gray-300">
            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">1. Descrizione del Servizio</h2>
              <p className="mb-4">
                Legis è un’applicazione mobile e web che offre strumenti di ricerca e consultazione di testi giuridici,
                normativi, giurisprudenziali e atti ufficiali (“Servizio”) in modo deterministico (full-text e indici
                normativi; nessuna IA generativa in questa versione).                 Il Servizio è freemium: uso gratuito entro soglie
                (10 ricerche iniziali e 3 ricerche gratuite al giorno) e abbonamenti in-app mensili e annuali,
                auto-rinnovanti, acquistabili esclusivamente tramite Apple App Store o Google Play per ricerche
                illimitate. Cronologia e “Miei salvati” sono
                conservati esclusivamente sul dispositivo dell’Utente.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">
                2. Esclusione di responsabilità – non è consulenza legale (Disclaimer)
              </h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>
                  <span className="text-white font-medium">Assenza di consulenza legale: </span>
                  i contenuti e i dati di Legis hanno scopo puramente informativo e di supporto alla ricerca. L’App non
                  fornisce consulenza legale o pareri professionali e non sostituisce l’assistenza di un avvocato o
                  professionista abilitato.
                </li>
                <li>
                  <span className="text-white font-medium">Accuratezza dei dati: </span>
                  il Titolare si adopera per banche dati aggiornate e accurate, ma non garantisce esaustività,
                  completezza, esattezza o aggiornamento costante dei testi. L’Utente deve verificare i testi ufficiali
                  sulle fonti primarie (es. Gazzetta Ufficiale, banche dati giudiziarie ufficiali).
                </li>
                <li>
                  <span className="text-white font-medium">Assenza di garanzie di risultato: </span>
                  il Titolare non è responsabile per decisioni legali, strategie processuali o atti redatti dall’Utente
                  sulla base dei risultati di ricerca.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">3. Account, registrazione ed età minima</h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>
                  L’accesso richiede un account creato tramite OAuth Apple, Google o Microsoft, con dati accurati. Il
                  Servizio non è rivolto a minori di 14 anni; sotto i 14 anni serve il consenso del titolare della
                  responsabilità genitoriale. LegisRatio non riceve né conserva le password: l’autenticazione avviene
                  presso il provider OAuth.
                </li>
                <li>
                  L’Utente è responsabile della riservatezza dell’accesso al proprio account/dispositivo e di tutte le
                  attività svolte tramite il proprio account. Su un nuovo dispositivo l’Utente può ripristinare le
                  funzioni da abbonato accedendo con lo stesso account Legis e lo stesso ID Apple/Google usati per
                  l’acquisto, tramite la funzione “Ripristina acquisti” e le impostazioni dello store.
                </li>
                <li>
                  Il Titolare può sospendere o chiudere account per violazioni dei Termini o uso improprio/fraudolento.
                  L’Utente può cancellare l’account in-app (Impostazioni &gt; Elimina account) o scrivendo a{' '}
                  <a href="mailto:privacy@legisratio.it" className="text-mystic-violet hover:text-cosmic-teal underline">
                    privacy@legisratio.it
                  </a>
                  , come descritto nell’Informativa privacy (cancellazione server + backup entro 30 giorni; dati sul
                  dispositivo cancellati in-app/disinstallazione).
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">4. Licenza d’uso e proprietà intellettuale</h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>
                  Il Titolare concede all’Utente una licenza personale, non esclusiva, non trasferibile, revocabile e
                  limitata per scaricare, installare e utilizzare Legis per fini personali o professionali interni, in
                  conformità ai presenti Termini.
                </li>
                <li>
                  Tutti i diritti di proprietà intellettuale sull’Applicazione (marchi, loghi, codice, grafica,
                  interfacce, algoritmi e struttura del database) appartengono al Titolare o ai suoi licenzianti.
                </li>
                <li>
                  All’Utente è fatto espresso divieto di:
                  <ul className="list-disc pl-6 mt-3 space-y-2">
                    <li>Copiare, modificare, decompilare o effettuare reverse engineering dell&apos;App;</li>
                    <li>
                      Utilizzare bot, spider, scraper o altri mezzi automatizzati per estrarre massivamente dati
                      dall&apos;App o dalle sue banche dati;
                    </li>
                    <li>Rivendere, sublicenziare o concedere in locazione il Servizio a terzi.</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">5. Piani, abbonamenti in-app e pagamenti</h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>
                  <span className="text-white font-medium">Piani disponibili: </span>
                  uso gratuito entro soglie (10 ricerche iniziali e 3 ricerche gratuite al giorno) e abbonamenti in-app
                  mensili e annuali, auto-rinnovanti, per ricerche illimitate. Prezzi
                  (IVA inclusa ove applicabile), durate ed eventuali offerte sono indicati in Apple
                  App Store o Google Play al momento dell’acquisto e possono variare; eventuali modifiche di prezzo
                  sono comunicate secondo le regole dello store.
                </li>
                <li>
                  <span className="text-white font-medium">Acquisto esclusivamente via store: </span>
                  gli abbonamenti si acquistano solo tramite Apple App Store (su iOS) o Google Play (su Android) con
                  l’account store dell’Utente. L’addebito avviene sul metodo di pagamento collegato a tale account. Per
                  tutto ciò che riguarda pagamento, fatturazione e addebiti si applicano i termini di vendita di Apple
                  (Apple Media Services Terms) o Google (Google Play Terms); LegisRatio non tratta dati di carte,
                  non emette fatture per gli abbonamenti e non può addebitare importi.
                </li>
                <li>
                  <span className="text-white font-medium">Rinnovo automatico e disdetta: </span>
                  l’abbonamento si rinnova automaticamente alla scadenza per un periodo uguale, salvo disdetta
                  effettuata almeno 24 ore prima (o entro il termine indicato dallo store) dalle impostazioni
                  dell’account Apple/Google (es. Impostazioni iOS &gt; ID Apple &gt; Abbonamenti; Play Store &gt;
                  Pagamenti e abbonamenti). In mancanza di disdetta, lo store addebita il periodo successivo. La disdetta
                  ha effetto alla fine del periodo già pagato; LegisRatio non può disdire abbonamenti dallo store per
                  conto dell’Utente.
                </li>
                <li>
                  <span className="text-white font-medium">Gestione, fatture e rimborsi: </span>
                  gestione dell’abbonamento, ricevute/fatture, cambi piano, sospensioni e rimborsi avvengono
                  esclusivamente secondo le regole e le procedure di Apple o Google. LegisRatio non gestisce rimborsi
                  né assistenza sui pagamenti.
                </li>
                <li>
                  <span className="text-white font-medium">Mancato pagamento e ripristino: </span>
                  in caso di mancato rinnovo l’accesso alle funzioni da abbonato decade alla scadenza del periodo pagato,
                  restando disponibile l’uso gratuito entro soglie. Su nuovi dispositivi usare stesso account Legis e
                  stesso ID store e la funzione “Ripristina acquisti”.
                </li>
                <li>
                  <span className="text-white font-medium">Diritto di recesso (contenuti/servizi digitali): </span>
                  acquistando un abbonamento con esecuzione immediata e download/uso immediato del contenuto o servizio
                  digitale, l’Utente chiede espressamente l’inizio immediato dell’esecuzione e riconosce di perdere il
                  diritto di recesso di 14 giorni ex art. 59, comma 1, lett. o) del Codice del Consumo (D.Lgs. 206/2005),
                  salve le policy di rimborso di Apple/Google che restano applicabili tramite lo store.
                </li>
                <li>
                  <span className="text-white font-medium">Modifiche all’offerta: </span>
                  il Titolare può modificare piani, soglie gratuite e funzionalità, con preavviso in-app/sul sito per le
                  modifiche rilevanti; restano ferme le condizioni del periodo già pagato e le regole dello store su
                  rinnovi e variazioni di prezzo.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">6. Disponibilità del Servizio e limitazione di responsabilità</h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>
                  Il Titolare farà quanto ragionevolmente possibile per la continuità del Servizio, ma non garantisce
                  disponibilità ininterrotta o assenza di errori, bug o interruzioni (incluse attività di manutenzione).
                </li>
                <li>
                  Nei limiti massimi consentiti dalla legge, il Titolare non è responsabile per danni diretti, indiretti,
                  incidentali o consequenziali (incluse perdita di profitto, perdita di dati o interruzione di attività)
                  derivanti dall’uso o impossibilità di uso di Legis. Nulla esclude la responsabilità inderogabile per
                  legge (es. dolo/colpa grave, tutela consumatori).
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">7. Protezione dei dati personali</h2>
              <p className="mb-4">
                Il trattamento avviene secondo il GDPR (Reg. UE 2016/679) e la normativa nazionale. Dettagli
                nell’Informativa privacy pubblicata all’URL pubblico del sito e mostrata in-app prima della
                registrazione: query su server SEE max 10 secondi poi cancellate, cronologia e salvati solo sul
                dispositivo, login OAuth Apple/Google/Microsoft, nessuna analytics di terzi, log 1 anno, backup 1 anno,
                abbonamenti in-app solo via Apple/Google con verifica on-device e nessun dato di pagamento al Titolare.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">8. Modifiche ai Termini</h2>
              <p className="mb-4">
                Il Titolare può modificare i Termini; le modifiche entrano in vigore alla pubblicazione nell’App/sul sito,
                con preavviso in-app o via email per quelle rilevanti. L’uso continuato dopo l’entrata in vigore
                costituisce accettazione dei nuovi Termini.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">9. Legge applicabile e foro competente</h2>
              <ol className="list-decimal pl-6 mb-4 space-y-3">
                <li>I presenti Termini sono regolati e interpretati secondo la legge italiana.</li>
                <li>
                  Per le controversie è competente in via esclusiva il Foro di Milano, fatti salvi i fori inderogabili a
                  tutela dei consumatori.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">10. Contatti</h2>
              <p className="mb-4">
                Per domande o segnalazioni sui Termini o sull’uso di Legis:{' '}
                <a href="mailto:privacy@legisratio.it" className="text-mystic-violet hover:text-cosmic-teal underline">
                  privacy@legisratio.it
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegisTerms;
